import type {
  JourneyRequest,
  JourneyVerifyRequest,
} from '../../domain/models/journey'
import type { IJourney } from '../../domain/use-cases/i-journey'

export class JourneyController {
  constructor(private readonly repository: IJourney) {}

  async getJourney(params: JourneyVerifyRequest) {
    try {
      const result = await this.repository.getJourney(params)
      return result
    } catch (error) {
      throw error
    }
  }

  async createJourney(params: JourneyRequest) {
    try {
      const result = await this.repository.createJourney(params)
      return result
    } catch (error) {
      throw error
    }
  }

  async concludeJourney(journeyId: number) {
    try {
      const result = await this.repository.concludeJourney(journeyId)
      return result
    } catch (error) {
      throw error
    }
  }
}
